import { FileCopyOutlined } from '@mui/icons-material'
import { bomItemActivitiesSelectors } from 'features/BillOfMaterials/store/selectors/activities/bomItemActivitiesSelectors'
import { isEqual } from 'lodash'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BoMItemActivityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppSelector } from 'store/configureStore'
import { materialActions } from 'store/MaterialSelector/MaterialsReducer'
import { BomItemMenuItem } from './BomItemMenuItem'

export const CopyActivityKeywordsMenuItem = ({
  bomItemPointer,
  onClose,
  dataTestId,
}: {
  bomItemPointer: BomItemPointer
  onClose: () => void
  dataTestId?: string
}) => {
  const bomItemActivities: BoMItemActivityDto[] = useAppSelector(
    bomItemActivitiesSelectors.allActivities(bomItemPointer),
    isEqual,
  )

  return (
    <BomItemMenuItem
      dataTestId={dataTestId}
      primaryTextTranslationKey="project:copy-material"
      icon={<FileCopyOutlined />}
      disableIfNotEditable
      action={materialActions.copyActivityToClipboard}
      actionParams={{
        baseBomItemPointer: bomItemPointer,
        activities: bomItemActivities,
      }}
      closeOnClick
      onClose={onClose}
    />
  )
}
